import React, { useEffect, useState } from 'react';
import { Card, Descriptions, Radio, Tag, Typography, Image, List, Divider, Skeleton } from "antd";
import { MDBCol } from "mdbreact";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { getDownloadURL, getStorage, listAll, ref as storageRef } from "firebase/storage";
import moment from "moment";

const { Title, Text } = Typography;

var db = getDatabase(Firebase);
var storage = getStorage(Firebase);

const ViewStory = (props) => {
	const [users, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
	const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
	const [orgArray, orgsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [groupArray, groupsLoading] = useListVals(ref(db, "talmidsdb/groups"));
	const [languageArray, languagesLoading] = useListVals(ref(db, "talmidsdb/languages"));
	const [consents, consentsLoading] = useListVals(ref(db, "talmidsdb/consents"));
	const [isIndividual, setIsIndividual] = useState(false);
	const [urlArray, setUrlArray] = useState([]);
	const [mediaLoading, setMediaLoading] = useState(false);

	useEffect(() => {
		setUrlArray([]);
		setMediaLoading(true);
		if (props.story?.storySourceType === "individual" || props.story?.storySourceType === "family") {
			setIsIndividual(true);
		} else {
			setIsIndividual(false);
		}
		const storyIdToUse = props.story?.storyID || props.story?.id || props.story?.key;
		const paths = [
			"talmidsdb/successStories/" + storyIdToUse + "/",
			"talmidsdb/SuccessStories/" + storyIdToUse + "/",
			"System/SuccessStories/" + storyIdToUse + "/",
		];
		Promise.all(paths.map((path) => listAll(storageRef(storage, path)).catch(() => ({ items: [] }))))
			.then((results) => {
				const refs = results.flatMap((res) => res.items || []);
				Promise.allSettled(refs.map((itemRef) => getDownloadURL(itemRef)))
					.then((outcomes) => {
						const urls = outcomes.filter(o => o.status === 'fulfilled').map(o => o.value);
						setUrlArray(Array.from(new Set(urls)));
						setMediaLoading(false);
					})
					.catch(() => {
						setUrlArray([]);
						setMediaLoading(false);
					});
			});
	}, [props.story?.storyID, props.story?.storySourceType]);

	const getDisplayValue = (id, array, idField, nameField) => {
		const item = array?.find(i => i[idField] === id);
		return item ? item[nameField] : id;
	};

	const getConsentName = (id) => {
		const consent = consents?.find(c => c.consentRequestID === id);
		return consent ? consent.fullName : id;
	};

	const getUserName = (id) => {
		const user = users?.find(u => u.id === id);
		return user ? `${user.firstname} ${user.surname}` : id;
	};

	const story = props.story || {};
	const isLookupLoading = usersLoading || communitiesLoading || orgsLoading || groupsLoading ||
		languagesLoading || consentsLoading || mediaLoading;

	if (isLookupLoading) {
		return <Skeleton active avatar paragraph={{ rows: 12 }} />;
	}

	return (
		<MDBCol md={24}>
			<Card title={<Title level={3}>{story.storyTitle || "Story Details"}</Title>}>
				<Descriptions column={1} bordered>
					<Descriptions.Item label="Language">
						{getDisplayValue(story.language, languageArray, "languageID", "languageName")}
					</Descriptions.Item>
					<Descriptions.Item label="Community">
						{getDisplayValue(story.community, communityArray, "communityID", "name")}
					</Descriptions.Item>

					<Descriptions.Item label="Organization">
						{getDisplayValue(story.organisation, orgArray, "orgID", "name")}
					</Descriptions.Item>
					<Descriptions.Item label="Group">
						{getDisplayValue(story.groupID, groupArray, "id", "groupSelfName")}
					</Descriptions.Item>
					<Descriptions.Item label="Submitted By">
						{getUserName(story.submittedBy)}
					</Descriptions.Item>
					<Descriptions.Item label="Participants Name">
						{story.participantsName}
					</Descriptions.Item>
					<Descriptions.Item label="Story's source type">
						<Tag color="blue">{story.storySourceType}</Tag>
					</Descriptions.Item>
					<Descriptions.Item label="Gender of participants">
						{story.gender}
					</Descriptions.Item>
					{isIndividual && (
						<>
							<Descriptions.Item label="Marital Status">
								{Array.isArray(story.maritalStatus) ? story.maritalStatus.join(", ") : story.maritalStatus}
							</Descriptions.Item>
							<Descriptions.Item label="Number of Living Male Children">
								{story.maleChildren || "Not specified"}
							</Descriptions.Item>
							<Descriptions.Item label="Number of Living Female Children">
								{story.femaleChildren || "Not specified"}
							</Descriptions.Item>
						</>
					)}
					<Descriptions.Item label="Story's Key Topic">
						{story.storyTopic}
					</Descriptions.Item>
				</Descriptions>
				<Divider orientation="left">Story Content</Divider>
				<Card type="inner" title="Life before Intervention By Organization">
					<Text>{story.situationBefore}</Text>
				</Card>
				<Card type="inner" title="What did the Organization do" style={{ marginTop: 16 }}>
					<Text>{story.whatHappened}</Text>
				</Card>
				<Card type="inner" title="Life after Intervention By Organization" style={{ marginTop: 16 }}>
					<Text>{story.situationAfter}</Text>
				</Card>
				<Card type="inner" title="Life Change Summary" style={{ marginTop: 16 }}>
					<Text>{story.lifeChange}</Text>
				</Card>
				<Card type="inner" title="One Quote from Story" style={{ marginTop: 16 }}>
					<Text italic>{story.quote}</Text>
				</Card>
				<Card type="inner" title="Story Author / Narrator" style={{ marginTop: 16 }}>
					<Text>{story.storyAuthor || "Not specified"}</Text>
				</Card>
				<Card type="inner" title="Prayer Request" style={{ marginTop: 16 }}>
					<Text>{story.prayerRequest || "Not specified"}</Text>
				</Card>
				<Divider orientation="left">Media</Divider>
				<List
					grid={{ gutter: 16, column: 3 }}
					dataSource={urlArray}
					renderItem={(url, index) => (
						<List.Item>
							<Card
								cover={<Image src={url} alt={`Story photo ${index + 1}`} />}
							>
								<Card.Meta title={`Photo ${index + 1}`} />
							</Card>
						</List.Item>
					)}
				/>
				<Divider orientation="left">Additional Information</Divider>
				<Descriptions column={2} bordered>
					<Descriptions.Item label="Consent">
						{story.consent ? getConsentName(story.consent) : "Not specified"}
					</Descriptions.Item>

					<Descriptions.Item label="Act of Love">
						<Tag color={story.actOfLove === "Yes" ? "green" : "red"}>{story.actOfLove || "No"}</Tag>
					</Descriptions.Item>

					<Descriptions.Item label="Security Risk">
						<Tag color={story.securityRisk === "Yes" ? "red" : "green"}>{story.securityRisk || "No"}</Tag>
					</Descriptions.Item>

					<Descriptions.Item label="Submitted Previously">
						<Tag color={story.submittedPreviously === "Yes" ? "orange" : "green"}>{story.submittedPreviously || "No"}</Tag>
					</Descriptions.Item>

					<Descriptions.Item label="Added By">
						{getUserName(story.addedByUser)}
					</Descriptions.Item>

					<Descriptions.Item label="Date Added">
						{moment(story.dateCreated, "YYYY-MM-DDTh:mm:ss").format("YYYY/MMM/DD HH:mm")}
					</Descriptions.Item>
				</Descriptions>
			</Card>
		</MDBCol>
	);
};

export default ViewStory;
